import { Component, Injector, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AttachmentsBaseComponent } from '../attachment-base/attachment-base.component';

@Component({
  selector: 'app-attachments-modal',
  templateUrl: './attachments-modal.component.html',
  styleUrls: ['./attachments-modal.component.css']
})
export class AttachmentsModalComponent extends AttachmentsBaseComponent implements OnInit {
  title: string;
  closeBtnName = 'Close';

  constructor(public activeModal: NgbActiveModal, public _injector: Injector) {
    super(_injector);
  }

  ngOnInit(): void {
    super.LoadAttachments();
  }

  closeModal() {
    this.activeModal.close();
  }
}
